<template>
  <section>
    <b-modal
      id="merge-orders-modal"
      ref="merge-orders-modal"
      data-cy="ticket-merge-orders-modal"
      :static="true"
      :size="'lg'"
      no-close-on-backdrop
      :title="$t('message.ticketOverview.ticket.actions.mergeOrders')"
      @close="hide()"
      @show="show">
      <div class="row">
        <p class="col-12 mb-0">
          {{ $t('message.ticketOverview.ticket.mergeOrders.modal.description1') }}
        </p>
        <p class="col-12 mb-0">
          {{ $t('message.ticketOverview.ticket.mergeOrders.modal.description2') }}
        </p>
        <p class="col-12 mb-0">
          {{ $t('message.ticketOverview.ticket.mergeOrders.modal.description3') }}
        </p>
        <div class="col-12">
          <b-table
            data-cy="ticket-merge-orders-table"
            bordered
            hover
            thead-class="hidden_header"
            class="mt-3"
            :fields="fields"
            :items="sortedLinkedOrders">
            <!-- Data -->
            <template #cell(checkbox)="data">
              <coozzy-form-checkbox
                v-if="data.item.status === 'TICKET_STATUS_DRAFT'"
                :id="'check_' + data.item.id"
                data-cy="ticket-merge-orders-checkbox"
                @change="(value) => { itemSelected(data.item, value) }" />
            </template>
            <template #cell(ticket)="data">
              <div
                :key="'link_' + data.item.id"
                class="row mx-0 p-1 linked-row">
                <div class="col-8 p-0 align-self-center">
                  <router-link
                    :to="{ name: getTicketDetailRoute(data.item).name, params: getTicketDetailRoute(data.item).params }"
                    target="_blank">
                    <img
                      v-b-tooltip="{placement : 'left', title : $t('message.ticketOverview.ticket.type.' + data.item.type)}"
                      height="20px"
                      class="mr-1"
                      :src="`/img/ticket/${data.item.type.split('TICKET_TYPE_')[1].toLowerCase()}.svg`"
                      alt="type"> {{ data.item.key }}
                    {{ data.item.title }}
                  </router-link>
                </div>
                <div
                  class="col d-flex">
                  <img
                    height="20px"
                    class="align-self-center mr-2 float-right ml-2"
                    :src="`/img/priority/prio-${data.item.priority}.svg`"
                    alt="priority">
                  <img
                    v-b-tooltip="{container: '#merge-orders-modal', title: data.item.assignee ? data.item.assignee.name : ''}"
                    class="align-self-center float-right avatar mr-2"
                    :src="data.item.assignee ? data.item.assignee.profilePictureUrl ? data.item.assignee.profilePictureUrl : '/avatar.png' : '/avatar.png'"
                    alt="assignee">
                  <div
                    :class="`float-right status-design ${(data.item.status.split('TICKET_STATUS_')[1]).toLowerCase()}`">
                    {{
                      $t('message.ticketOverview.status.' + data.item.status)
                    }}
                  </div>
                </div>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 float-right">
          <coozzy-button
            data-cy="ticket-merge-orders-confirm-btn"
            size="normal"
            design="green"
            class="float-right save-btn"
            :disabled="selectedOrders.length <= 1"
            @click="saveClicked">
            {{ $t('message.ticketOverview.ticket.mergeOrders.modal.merge') }}
          </coozzy-button>
          <coozzy-button
            data-cy="ticket-merge-orders-cancel-btn"
            size="normal"
            class="float-left"
            @click="hide()">
            {{ $t('message.generic.cancel') }}
          </coozzy-button>
        </div>
      </template>
    </b-modal>
  </section>
</template>
<script>

import { routeChecks } from '@/mixins/routeChecks'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'
import CoozzyFormCheckbox from '@/framework/components/form/checkbox/CoozzyFormCheckbox.vue'

export default {
  name: 'MergeOrdersModal',
  components: {
    CoozzyFormCheckbox,
    CoozzyButton
  },
  mixins: [routeChecks],
  props: {
    mainTicket: {
      type: Object,
      required: true
    },
    linkedOrders: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedOrders: [],
      fields: [
        {
          key: 'checkbox',
          label: '',
          thClass: '',
          tdClass: 'border-right-0 checkbox-cell pr-0 align-content-center'
        },
        {
          key: 'ticket',
          label: '',
          thClass: '',
          tdClass: 'pl-0'
        }
      ]
    }
  },
  computed: {
    sortedLinkedOrders() {
      // Sort linked orders by type draft first and then by key
      return [...this.linkedOrders].sort((a, b) => {
        if (a.status === 'TICKET_STATUS_DRAFT' && b.status !== 'TICKET_STATUS_DRAFT') {
          return -1
        } else if (a.status !== 'TICKET_STATUS_DRAFT' && b.status === 'TICKET_STATUS_DRAFT') {
          return 1
        } else {
          return a.key.localeCompare(b.key)
        }
      })
    }
  },
  methods: {
    saveClicked() {
      this.$emit('merge-orders', this.selectedOrders)
    },
    show() {
      this.$bvModal.show('merge-orders-modal')
    },
    hide() {
      this.$emit('hide')
      this.$bvModal.hide('merge-orders-modal')
    },
    itemSelected(element, checked) {
      if (checked && !this.selectedOrders.includes(element)) {
        this.selectedOrders.push(element)
      } else {
        this.selectedOrders = this.selectedOrders.filter(entry => entry.id !== element.id)
      }
    },
    getTicketDetailRoute(ticket) {
      if (this.isOwnerModule) {
        return {
          name: 'OwnerTicketDetailsView',
          params: { id: ticket.key }
        }
      } else if (this.isAdminModule) {
        return {
          name: 'AdminTicketDetailsView',
          params: { id: ticket.key }
        }
      } else if (this.isAssetModule) {
        return {
          name: 'AssetTicketDetailsView',
          params: { id: ticket.key }
        }
      } else if (this.isAccountingModule) {
        return {
          name: 'AccountingTicketDetailsView',
          params: { id: ticket.key }
        }
      } else {
        return {
          name: 'MarketingTicketDetailsView',
          params: { id: ticket.key }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.hidden_header) {
  display: none;
}
.status-design {
  min-width: 125px !important;
  text-align: center;
  padding: 0.35rem 0.5rem;
  text-transform: uppercase;
  font-size: small;
  border-radius: 0.2rem;

  &.open {
    background: lightgrey;
  }

  &.in_progress {
    background: lightskyblue;
  }

  &.done {
    background: darkseagreen;
  }
}
</style>
